import { createSlice } from "@reduxjs/toolkit";
import { animateCss } from "../../../pages/TosterAlert";
import {
  fetchPdfDocumentAction,
  getOrganizationDocumentAction,
  getUserOrganizationDocumentAction,
  organizationAwardsAction,
  organizationDocumentCheckAction,
  organizationDocumentIsActiveAction,
  organizationDocumentUploadAction,
} from "../../actions/OrganizationAction/organizationDocumentAction";
import {
  allOrganizationAction,
  createOrganizationAction,
  deleteOrganizationAction,
  isActiveOrganizationAction,
  updateOrganizationAction,
} from "../../actions/OrganizationAction/OrganizationAction";
import { emailOrgReportAction } from "../../actions/OrganizationAction/organizationReportsAction";

const organization = {
  pagination: {
    pageIndex: 0,
    pageSize: 10,
  },
  awardPagination: {
    pageIndex: 0,
    pageSize: 10,
  },
  profile: [],
  name: [],
  documents: [],
  awardDocuments: [],
  awardTotalCount: 0,
  awardLoading: false,
  pdfData: null,
  listLoading: false,
  createOrganizationDocument: {
    loading: false,
    error: "",
  },
  awardSorting: [],
  loading: false,
  error: null,
  message: null,
  totalCount: 0,
};

const organizationSlice = createSlice({
  name: "organization",
  initialState: organization,
  reducers: {
    resetOrganization: (state, { payload }) => {
      state = { ...state, ...organizationSlice.createOrganizationDocument };
      return state;
    },
    setMasterPaginationReducer: (state, action) => {
      return {
        ...state,
        pagination: action.payload
      };
    },
    resetMasterPaginationReducer: (state) => {
      return {
        ...state,

        pagination: {
          ...state.pagination,
          pageIndex: 0
        }
      };

    },
    setMasterPaginationSize: (state, action) => {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          pageIndex: 0,
          pageSize: action.payload
        }
      };
    },
    //Award Pagination
    setAwardPaginationReducer: (state, action) => {
      return {
        ...state,
        awardPagination: action.payload
      };
    },
    resetAwardPaginationReducer: (state) => {
      return {
        ...state,

        awardPagination: {
          ...state.awardPagination,
          pageIndex: 0
        }
      };

    },
    setAwardPaginationSize: (state, action) => {
      return {
        ...state,
        awardPagination: {
          ...state.awardPagination,
          pageIndex: 0,
          pageSize: action.payload
        }
      };
    },
    setAwardSortingReducer: (state, action) => {
      return {
        ...state,
        awardSorting: action.payload
      };
    },
    resetAwardDocumentsReducer: (state) => {
      state.awardDocuments = [];
      state.awardTotalCount = 0;
      state.awardLoading = false;
    },
  },
  extraReducers: (builder) =>
    builder

      .addCase(allOrganizationAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(allOrganizationAction.fulfilled, (state, action) => {
        state.profile = action.payload?.data;
        state.name = action.payload?.orgName;
        state.loading = false;
        return state;
      })
      .addCase(allOrganizationAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createOrganizationAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(createOrganizationAction.fulfilled, (state, action) => {
        if (action.payload.message) {
          animateCss(action?.payload?.alert, action?.payload?.message, 1000);
          state.loading = false;
          return state;
        } else if (!action.payload.message) {
          animateCss("error", action.payload.message, 1000);
        }
      })
      .addCase(createOrganizationAction.rejected, (state, action) => {
        animateCss(action?.payload?.alert, action?.payload?.message, 1000);
        state.loading = false;
      })
      .addCase(updateOrganizationAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(updateOrganizationAction.fulfilled, (state, action) => {
        if (action.payload.message) {
          animateCss(action?.payload?.alert, action?.payload?.message, 1000);
          state.loading = false;
          return state;
        } else if (!action.payload.message) {
          animateCss("error", "Organization Not Create", 1000);
        }
      })
      .addCase(updateOrganizationAction.rejected, (state, action) => {
        animateCss(action?.payload?.alert, action?.payload?.message, 1000);
        state.loading = false;
      })
      .addCase(isActiveOrganizationAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(isActiveOrganizationAction.fulfilled, (state, action) => {
        state.loading = false;
        return state;
      })
      .addCase(isActiveOrganizationAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteOrganizationAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteOrganizationAction.fulfilled, (state, action) => {
        if (action.payload.data) {
          animateCss("success", "Organization Delete Successfully");
        } else if (!action?.payload?.data) {
          animateCss("warn", "Organization Associate to Others");
        }
        state.loading = false;
        return state;
      })
      .addCase(deleteOrganizationAction.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getOrganizationDocumentAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getOrganizationDocumentAction.fulfilled, (state, action) => {
        state.documents = action.payload;
        state.totalCount =
          action.payload?.totalCount ??
          action.payload?.absoluteTotalCount ??
          (Array.isArray(action.payload)
            ? action.payload.length
            : action.payload?.data?.length ?? 0);
        state.loading = false;
        return state;
      })
      .addCase(getOrganizationDocumentAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getUserOrganizationDocumentAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getUserOrganizationDocumentAction.fulfilled, (state, action) => {
        state.documents = Array.isArray(action.payload)
          ? action.payload
          : (Array.isArray(action.payload?.data)
              ? action.payload.data
              : (Array.isArray(action.payload?.documents) ? action.payload.documents : []));
        state.loading = false;
        return state;
      })
      .addCase(getUserOrganizationDocumentAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(organizationAwardsAction.pending, (state, action) => {
        state.loading = true;
        state.awardLoading = true;
      })
      .addCase(organizationAwardsAction.fulfilled, (state, action) => {
        const docs = action.payload?.data ?? [];
        const count = action.payload?.totalCount ?? 0;
        state.awardDocuments = docs;
        state.awardTotalCount = count;
        state.loading = false;
        state.awardLoading = false;
        return state;
      })
      .addCase(organizationAwardsAction.rejected, (state, action) => {
        state.loading = false;
        state.awardLoading = false;
      })
      .addCase(organizationDocumentUploadAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(organizationDocumentUploadAction.fulfilled, (state, action) => {
        if (action.payload.data.message == "success") {
          animateCss("success", "Organization Document Upload Successfully");
          return state;
        }
      })
      .addCase(organizationDocumentUploadAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(organizationDocumentIsActiveAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(
        organizationDocumentIsActiveAction.fulfilled,
        (state, action) => {
          if (action.payload.status) {
            animateCss("success", "Organization Document Active");
            return state;
          } else if (!action.payload.status) {
            animateCss("success", "Organization Document Deleted", 3000);
            return state;
          }
        }
      )
      .addCase(organizationDocumentIsActiveAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(organizationDocumentCheckAction.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(organizationDocumentCheckAction.fulfilled, (state, action) => {
        return state;
      })
      .addCase(organizationDocumentCheckAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchPdfDocumentAction.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        state.pdfData = null;
      })
      .addCase(fetchPdfDocumentAction.fulfilled, (state, action) => {
        if (action.payload && !action.payload?.message) {
          state.pdfData = action.payload;
          state.loading = false;
          state.error = null;
        } else {
          state.loading = false;
          state.error = true;
          state.message = action.payload.message;
        }
      })
      .addCase(fetchPdfDocumentAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error || "Unknown error";
        state.pdfData = null;
      })

      .addCase(emailOrgReportAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(emailOrgReportAction.fulfilled, (state, action) => {

        animateCss('success', 'Email sent successfully', 3000)
        state.loading = false;


        return state;
      })
      .addCase(emailOrgReportAction.rejected, (state, action) => {
        state.loading = false;
        return state;
      }),
});

export const { resetOrganization,
  setAwardPaginationReducer, resetAwardPaginationReducer, setAwardPaginationSize, resetAwardDocumentsReducer,
  setMasterPaginationReducer, resetMasterPaginationReducer, setMasterPaginationSize,
  setAwardSortingReducer
} = organizationSlice.actions;
export default organizationSlice.reducer;

